import React from 'react'
import { ImgSvg } from '../Icons/img'

interface CardComponentProps {
  classNames: string
  CardDataOption: any[]
}

const CardComponent: React.FC<CardComponentProps> = ({ CardDataOption, classNames }) => {
  return (
    <div className={classNames}>
        {
            CardDataOption.map((res: any, indexCard: number) => (
                <div key={indexCard}>
                    <div className="bg-white border border-l-[#fff] border-t-[#fff] border-r-[#fff] rounded-lg shadow w-full">
                        <div className='p-6'>
                            <p className="font-normal font-[Montserrat] leading-[17.942px] not-italic text-[13.22px] text-[#121212]">{res.title}</p>
                            <div className='grid grid-cols-2'>
                                <div className='font-bold font-[Montserrat] leading-[31.162px] not-italic text-[22.663px] text-[#121212]'>{res.amount}</div>
                                <div className='font-medium font-[Montserrat] leading-[17.942px] not-italic text-[18.2px] text-[#121212] flex items-center'>{res.totalPercent}</div>
                            </div>
                        </div>
                        <div className='w-full'>
                            <ImgSvg className='w-full' />
                        </div>
                    </div>
                </div>
            ))
        }
    </div>
  )
}

export default CardComponent
